import { handleResponse } from '@/services/handleresponse'
const API_URL = "https://api.irmastore.id/apps/account"
// const API_URL = "http://localhost:8082/apps/account"

export const DeleteAccountService = {
  getListDeleteAccount,
  getPendingDeleteAccount,
  updateStatusPending
}

function getListDeleteAccount (opt) {
  const { page, size } = opt

  const pageData = page - 1
  console.log()
  return fetch(API_URL + `/list-delete?page=${pageData}&size=${size}`, {
    method: "GET",
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + localStorage.getItem('token')
    }
  }).then(handleResponse)
  .then(data => {
    return data
  })
}

function getPendingDeleteAccount(){
  return fetch(API_URL + "/delete-count", {
    method: "GET",
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + localStorage.getItem('token')
    }
  }).then(handleResponse)
  .then(data => {
    return data
  })
}

function updateStatusPending(opt){
  return fetch(API_URL + "/delete", {
    method: "PUT",
    headers: { 
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + localStorage.getItem('token')
    },
    body: JSON.stringify(opt)
  }).then(handleResponse)
  .then(data => {
    return data
  })
}